/*
  speelgoes — voortgang van je verzamellijsten op het verlanglijstje.
  Leest spg-verzamel-<serie> uit de browser (het account zet die daar via speelgoes-account.js).
  Altijd alle series, zodat je ziet wat er is: begonnen series met "5 van de 21" en een balk, de rest met "Begin je lijst".
  Alleen bij je eigen lijstje, niet bij een gedeelde link. Series en totalen: snippets/speelgoes-verzamelseries.liquid.
*/
(() => {
  const blok = document.querySelector('[data-spg-verzamel-voortgang]');
  if (!blok) return;
  const lees = (sel) => { try { return JSON.parse(document.querySelector(sel).textContent); } catch (_) { return null; } };
  const SERIES = lees('script[data-spg-verzamelseries]') || [];
  const CFG = lees('script[data-spg-vv-tekst]') || {};
  const T = CFG.tekst || {};
  const tk = (k, nl, v) => String(typeof T[k] === 'string' && T[k] ? T[k] : nl).replace(/\{(\w+)\}/g, (m, n) => (v && v[n] != null ? String(v[n]) : m));
  const taal = CFG.taal || 'nl';
  const root = (CFG.root || '/').replace(/\/$/, '');
  const naam = (s) => (s.naam && (s.naam[taal] || s.naam.nl)) || s.id;
  const link = (s) => root + s.pad + '#verzamellijst';
  const meld = (n, d) => { try { window.Shopify?.analytics?.publish?.('spg_vv_' + n, d || {}); } catch (_) { /* meten breekt nooit de pagina */ } };

  const stand = (s) => {
    let d = null;
    try { d = JSON.parse(localStorage.getItem('spg-verzamel-' + s.id) || 'null'); } catch (_) { /* geen opslag */ }
    const heb = Array.isArray(d && d.heb) ? d.heb.length : 0;
    const wil = Array.isArray(d && d.wil) ? d.wil.length : 0;
    return { heb: Math.min(heb, s.totaal), wil };
  };
  const el = (tag, attrs, ...kids) => {
    const e = document.createElement(tag);
    Object.entries(attrs || {}).forEach(([k, v]) => { if (v == null) return; if (k === 'tekst') e.textContent = v; else if (k.startsWith('on')) e.addEventListener(k.slice(2), v); else e.setAttribute(k, v); });
    kids.flat().forEach((k) => k != null && e.append(k));
    return e;
  };

  let getekend = '';
  const teken = () => {
    // Alleen bij je eigen lijstje: "Deel je lijstje" van jezelf, of je eigen lege lijstje (alleen dat heeft de bladerlink).
    const eigen = document.querySelector('.spg-lijst-delen:not(.spg-lijst-delen--gast), .spg-lijst-leeg__blader');
    // leeg eigen lijstje: laat ook de collecties zien om zelf rond te kijken
    const ontdek = document.querySelector('[data-spg-ontdek]');
    if (ontdek) ontdek.hidden = !document.querySelector('.spg-lijst-leeg__blader');
    // geen series in deze taal (de verzamellijsten zijn nu alleen Nederlands): geen blok
    if (!SERIES.length) { blok.hidden = true; return; }
    const rijen = SERIES.map((s) => ({ s, ...stand(s) }));
    const actief = rijen.filter((r) => r.heb || r.wil);
    const sleutel = eigen ? JSON.stringify(rijen.map((r) => [r.s.id, r.heb, r.wil])) : '';
    if (sleutel === getekend) return;
    getekend = sleutel;
    blok.hidden = !eigen;
    if (!eigen) return;
    // begonnen series eerst, daarna de rest in de volgorde van de data
    const volgorde = [...actief, ...rijen.filter((r) => !r.heb && !r.wil)];
    blok.replaceChildren(...[
      el('p', { class: 'spg-vv__kop', tekst: actief.length ? tk('kop', 'Je verzamellijsten') : tk('leeg_kop', 'Verzamel je LEGO?') }),
      actief.length ? null : el('p', { class: 'spg-vv__sub', tekst: tk('leeg_sub', 'Houd gratis bij welke sets je al hebt en welke je nog mist.') }),
      el('ul', { class: 'spg-vv__lijst' }, volgorde.map((r) => {
        const klik = () => meld('klik', { serie: r.s.id, plaats: r.heb || r.wil ? 'voortgang' : 'begin' });
        if (!r.heb && !r.wil) {
          return el('li', { class: 'spg-vv__rij is-nieuw' },
            el('a', { class: 'spg-vv__naam', href: link(r.s), onclick: klik, tekst: naam(r.s) }),
            el('span', { class: 'spg-vv__tal', tekst: tk('aantal', '{totaal} sets', { totaal: r.s.totaal }) }),
            el('span', { class: 'spg-vv__wil', tekst: tk('nul', 'Nog niet begonnen') }),
            el('a', { class: 'spg-vv__verder', href: link(r.s), onclick: klik, tekst: tk('begin', 'Begin je lijst') }));
        }
        const pct = Math.round((r.heb / r.s.totaal) * 100);
        const compleet = r.heb >= r.s.totaal;
        return el('li', { class: 'spg-vv__rij' },
          el('a', { class: 'spg-vv__naam', href: link(r.s), onclick: klik, tekst: naam(r.s) }),
          el('span', { class: 'spg-vv__tal', tekst: compleet ? tk('compleet', 'Compleet') : tk('stand', '{heb} van de {totaal}', { heb: r.heb, totaal: r.s.totaal }) }),
          el('span', { class: 'spg-vv__balk', role: 'progressbar', 'aria-label': naam(r.s), 'aria-valuemin': '0', 'aria-valuemax': String(r.s.totaal), 'aria-valuenow': String(r.heb) },
            el('span', { style: 'width:' + pct + '%' })),
          r.wil ? el('span', { class: 'spg-vv__wil', tekst: tk('wil', '{wil} op je verlanglijst', { wil: r.wil }) }) : el('span'),
          el('a', { class: 'spg-vv__verder', href: link(r.s), onclick: klik, tekst: tk('verder', 'Verder met je lijst') }));
      }))
    ].filter(Boolean));
  };

  let wacht = 0;
  const straks = () => { if (!wacht) wacht = requestAnimationFrame(() => { wacht = 0; teken(); }); };
  const podium = document.querySelector('[data-spg-lijst-podium]') || document.body;
  new MutationObserver(straks).observe(podium, { childList: true, subtree: true });
  document.addEventListener('spg-verzamel-extern', straks);
  window.addEventListener('storage', (e) => { if (!e.key || e.key.startsWith('spg-verzamel-')) straks(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', straks); else straks();
})();
